export const MultipleWifiNetworksEquipmentEnum = [
  'OXIAD-TPLHB610',
  'OXWIFI-TLHB610W7'
]



// WEBPACK FOOTER //
// ./src/assets/js/Enum/MultipleWifiNetworksEquipmentEnum.js